export enum AddOnType {
  POWER_DIALER_SINGLE = "POWER_DIALER_SINGLE",
  POWER_DIALER_MULTI = "POWER_DIALER_MULTI",
  AI_AGENT_INBOUND_BASIC = "AI_AGENT_INBOUND_BASIC",
  AI_AGENT_INBOUND_MEDIUM = "AI_AGENT_INBOUND_MEDIUM",
  AI_AGENT_INBOUND_PREMIUM = "AI_AGENT_INBOUND_PREMIUM",
  AI_AGENT_OUTBOUND_BASIC = "AI_AGENT_OUTBOUND_BASIC",
  AI_AGENT_OUTBOUND_MEDIUM = "AI_AGENT_OUTBOUND_MEDIUM",
  AI_AGENT_OUTBOUND_PREMIUM = "AI_AGENT_OUTBOUND_PREMIUM",
  CALL_RECORDING = "CALL_RECORDING",
  PRO_SUPPORT = "PRO_SUPPORT",
  PROPERTY_DATA_5K = "PROPERTY_DATA_5K",
  PROPERTY_DATA_10K = "PROPERTY_DATA_10K",
  WEBSITE_BUILDER = "WEBSITE_BUILDER",
}
